import React, {ReactNode} from 'react'

import {Button} from '@daedalus/atlas/Button'
import {Icon} from '@daedalus/atlas/Icon'
import {ANIMATION_TYPES, Overlay} from '@daedalus/atlas/Overlay'
import {ImageProvider} from '@daedalus/core/src/staticContent/types/ImageProvider'

import {AccommodationFloatingHeader} from '../AccommodationFloatingHeader'
import {
  backgroundColorStyles,
  Footer,
  GalleryWrapper,
  OverlayContent
} from './styles'
import {VirtualizedGallery} from './VirtualizedGallery'

interface Props {
  /** Is the overlay opened */
  isOpen: boolean
  /** RTL language */
  isRtl: boolean
  /** Array of image URLs */
  images: string[]
  /** First image to display after opening */
  initialImageIndex: number
  /** Add elements to the left side of the header (after the close button) */
  leftHeaderButtonSlot?: ReactNode
  /** Add elements to the right side of the header */
  rightHeaderButtonSlot?: ReactNode
  /** Add elements to the bottom of the overlay */
  footerSlot?: ReactNode
  /** Imaging service for resizing */
  imageProvider: ImageProvider
  /** Triggered whenever the user swipes the gallery */
  onSwipe?: () => void
  /** Triggered whenever the user zooms the gallery */
  onZoom?: () => void
  /** Handle overlay close */
  onClose: () => void
}

export const LightboxGalleryMobile = ({
  isOpen,
  isRtl,
  initialImageIndex,
  images,
  leftHeaderButtonSlot,
  rightHeaderButtonSlot,
  footerSlot,
  imageProvider,
  onSwipe,
  onZoom,
  onClose
}: Props) => {
  return (
    <Overlay
      enableBodyScrollLock
      isOpen={isOpen}
      shadeBackground={false}
      customStyles={backgroundColorStyles}
      animationType={ANIMATION_TYPES.NONE}
    >
      <OverlayContent>
        <GalleryWrapper>
          <VirtualizedGallery
            imageProvider={imageProvider}
            images={images}
            initialImageIndex={initialImageIndex}
            isRtl={isRtl}
            onSwipe={onSwipe}
            onZoom={onZoom}
            isZoomEnabled
          />
        </GalleryWrapper>
        {footerSlot ? <Footer>{footerSlot}</Footer> : null}
      </OverlayContent>
      <AccommodationFloatingHeader
        leftSlot={
          <>
            <Button
              variant="secondary"
              isRounded
              isFloating
              dataId="BackButton"
              iconStart={<Icon name="Close" />}
              onClick={onClose}
              size="lg"
            />
            {leftHeaderButtonSlot}
          </>
        }
        rightSlot={rightHeaderButtonSlot}
      />
    </Overlay>
  )
}
